import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { 
  Lock, Crown, Check, Lightning, Users, Receipt, 
  ChartLine, Wallet, WhatsappLogo, Star
} from '@phosphor-icons/react';

export const PremiumLock = ({ feature = "this feature" }) => {
  const navigate = useNavigate();

  const benefits = [
    { icon: Users, text: 'Unlimited Enquiry Management' },
    { icon: Receipt, text: 'Professional Invoices' },
    { icon: Wallet, text: 'Payment Tracking' },
    { icon: ChartLine, text: 'Business Analytics' },
    { icon: WhatsappLogo, text: 'WhatsApp Integration' },
    { icon: Star, text: 'Remove "Powered by" Branding' },
  ];

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-4 bg-gradient-to-br from-gray-50 to-orange-50">
      <Card className="max-w-md w-full border-2 border-orange-200 shadow-2xl">
        <CardContent className="pt-8 pb-8 text-center">
          {/* Lock Icon */}
          <div className="mb-6">
            <div className="w-20 h-20 mx-auto bg-gradient-to-br from-orange-100 to-pink-100 rounded-full flex items-center justify-center mb-4">
              <Lock className="h-10 w-10 text-[#FF5A36]" weight="duotone" />
            </div>
            <h2 className="font-['Chivo'] text-2xl font-black text-[#121212] mb-2">
              Premium Feature 🔒
            </h2>
            <p className="text-[#6B7280]">
              {feature} unlock करण्यासाठी Premium Plan घ्या
            </p>
          </div>

          {/* Price */}
          <div className="bg-gradient-to-r from-[#FF5A36] to-orange-500 rounded-2xl p-6 mb-6 text-white">
            <div className="flex items-center justify-center gap-2 mb-2">
              <Crown className="h-6 w-6" weight="fill" />
              <span className="text-lg font-bold">Premium Plan</span>
            </div>
            <div className="flex items-baseline justify-center gap-1">
              <span className="text-4xl font-black">₹99</span>
              <span className="text-white/80">/month</span>
            </div>
            <p className="text-white/80 text-sm mt-2">
              सर्व features unlock करा!
            </p>
          </div>

          {/* Benefits */}
          <div className="text-left mb-6 space-y-3">
            <p className="text-sm font-bold text-[#121212] mb-3">Premium मध्ये मिळेल:</p>
            {benefits.map((benefit, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <Check className="h-4 w-4 text-green-600" weight="bold" />
                </div>
                <span className="text-[#6B7280] text-sm">{benefit.text}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="space-y-3">
            <Button
              onClick={() => navigate('/premium')}
              className="w-full bg-gradient-to-r from-[#FF5A36] to-orange-500 hover:from-[#E04828] hover:to-orange-600 text-white rounded-full py-6 text-lg font-bold shadow-lg"
            >
              <Lightning className="h-5 w-5 mr-2" weight="fill" />
              Premium खरेदी करा - ₹99/month
            </Button>
            <Button
              variant="ghost"
              onClick={() => navigate('/dashboard')}
              className="w-full text-[#6B7280]"
            >
              नंतर करा
            </Button>
          </div>

          <p className="text-xs text-[#6B7280] mt-4">
            ✅ कधीही Cancel करा • ✅ Instant Access • ✅ 100% Secure
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PremiumLock;
